import fetchClient from 'lib/fetch_client'
import routes from 'server_routes'
import { INFLATE as INFLATE_USER_TXNS } from './user_txns'
import { getI18n } from 'client/i18n'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { CREATE_DNW_TRANSACTION_SUCCESS } from './dnw_transaction'

const MOCK_TXN_COUNT = 3
const i18n = getI18n('components/txns_list')

export const SET_TXN_LIST = 'pools/txns/SET_TXN_LIST'
export const FINISH_TXNS_SHOW_MORE = 'pools/txns/FINISH_UPLOAD'
export const FINISH_SHOW_MORE_ACTIVITIES = 'pools/txns/FINISH_ACTIVITIES'

export default function reducer(
  state = { list: [], txns_per_page: 10 },
  action
) {
  switch (action.type) {
    case FINISH_TXNS_SHOW_MORE: {
      const newTxns = action.payload.response && action.payload.response.txns

      return {
        ...state,
        list: [...state.list, ...newTxns.list],
      }
    }
    case SET_TXN_LIST:
      return { ...state, list: action.list, total: action.total }
    case INFLATE_USER_TXNS:
      return { ...state, list: [...action.payload.list, ...state.list] }
    case CREATE_DNW_TRANSACTION_SUCCESS: {
      const prevTxnCount = action.payload.prevTxnCount
      let contributionsCount
      if (prevTxnCount && prevTxnCount !== state.contributionsCount) {
        contributionsCount = state.contributionsCount
      }
      contributionsCount = state.contributionsCount + 1
      return {
        ...state,
        list: [action.payload.txn, ...state.list],
        contributionsCount: contributionsCount,
      }
    }
    default:
      return state
  }
}

export function mockForPreview(
  shareProgress,
  shareContributorsDetails,
  shareContributionsAmount
) {
  if (shareContributorsDetails || (shareContributionsAmount && shareProgress)) {
    return {
      type: SET_TXN_LIST,
      list: Array.from({ length: MOCK_TXN_COUNT }, (_, id) => ({
        id: id.toString(),
        campaign_id: NEW_CAMPAIGN_ID,
        sender_name: i18n(
          shareContributorsDetails ? 'participant_name' : 'anonymous'
        ),
        date: i18n('date'),
        amount: shareContributionsAmount ? 0 : undefined,
      })),
    }
  }
  return { type: SET_TXN_LIST, list: null }
}

export function showMoreTxns(campaignId, page, pageSize, transactionType) {
  // show more actually fetches just the photos of the additional txns, since the txns are already in the client.
  return (dispatch, getState) => {
    return fetchClient()
      .request(routes.contributors.api.transactions(), {
        method: 'GET',
        query: {
          page,
          pageSize,
          campaignId: campaignId,
          contribution_type: transactionType || 'CONTRIBUTION',
        },
      })
      .then(response => {
        if (transactionType === 'ALL') {
          dispatch(
            finishShowMoreActivities({
              ...response,
            })
          )
        } else {
          dispatch(
            finishShowMoreTxns({
              ...response,
            })
          )
        }
        return response
      })
      .catch(e => {
        dispatch(finishShowMoreTxns({}))
      })
  }
}

export function finishShowMoreTxns(response) {
  return { type: FINISH_TXNS_SHOW_MORE, payload: { response } }
}

export function finishShowMoreActivities(response) {
  return { type: FINISH_SHOW_MORE_ACTIVITIES, payload: { response } }
}
